import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {ConfigForm as _ConfigForm} from 'app-ui-componentlibrary/dist/componentLibrary/layout/ConfigForm';
import contentMap from 'componentLibrary';

export const ConfigForm = (props) => <_ConfigForm {...props} {...{contentMap}} />;
export const DynamicForm = connectWithCore(ConfigForm);
export default DynamicForm;
